module.exports = __webpack_public_path__ + "img/Flexbands.79d2cc06.png";